import { render, staticRenderFns } from "./search-contacts.vue?vue&type=template&id=0d0f89ca&scoped=true&"
import script from "./search-contacts.vue?vue&type=script&lang=js&"
export * from "./search-contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0f89ca",
  null
  
)

export default component.exports